export default function RecruitmentProcess({
                                               title = "Structured Recruitment Process",
                                               steps = [
                                                   {
                                                       stepNum: "STEP 01",
                                                       title: "Requirements",
                                                       description: "Employer provides demand letter and precise job specification."
                                                   },
                                                   {
                                                       stepNum: "STEP 02",
                                                       title: "Sourcing",
                                                       description: "Targeted nationwide sourcing via call center & online portal."
                                                   },
                                                   {
                                                       stepNum: "STEP 03",
                                                       title: "Screening",
                                                       description: "Verification of credentials, background & trade testing."
                                                   },
                                                   {
                                                       stepNum: "STEP 04",
                                                       title: "Medical Check",
                                                       description: "GAMCA & approved panel medical examinations."
                                                   },
                                                   {
                                                       stepNum: "STEP 05",
                                                       title: "Orientation",
                                                       description: "Safety protocols, trade brush-up & language orientation."
                                                   },
                                                   {
                                                       stepNum: "STEP 06",
                                                       title: "Visa Process",
                                                       description: "Document clearance & BMET smartcard issuance."
                                                   },
                                                   {
                                                       stepNum: "STEP 07",
                                                       title: "Flight Ticket",
                                                       description: "Group ticketing & pre-departure briefing."
                                                   },
                                                   {
                                                       stepNum: "STEP 08",
                                                       title: "Deployment",
                                                       description: "Successful on-site arrival & client handover."
                                                   }
                                               ],
                                               bgImage = "55.png"
                                           }) {
    return (
        <section className="recruitment-process-area pt-80 pb-80 position-relative overflow-hidden" style={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: 'contain',
            backgroundPosition: 'center',
            backgroundColor: '#ffffff',
        }}

        >
            <div className="container px-1 position-relative" style={{
                zIndex: 2
            }} >
                {/* Section Title */}
                <div className="row mb-5">
                    <div className="col-12">
                        <h2 className="fw-bold mb-2" style={{ color: '#0f172a' }}>{title}</h2>
                        <div className="divider" style={{ width: '60px', height: '4px', backgroundColor: '#2563eb', borderRadius: '2px' }}></div>
                    </div>
                </div>

                {/* Steps Grid (4 columns per row for 2 rows total) */}
                <div className="row g-4" >
                    {steps.map((item, index) => (
                        <div key={index} className="col-lg-3 col-md-6 col-sm-12">
                            <div
                                className="card border-0 shadow-sm h-100 p-4  shadow-lg"
                                style={{
                                    borderRadius: '20px',
                                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                                    backdropFilter: 'blur(5px)'
                                }}
                            >
                                <span className="text-primary fw-bold fs-7 mb-2 text-uppercase" style={{ letterSpacing: '1px', fontSize: '12px' }}>
                                    {item.stepNum}
                                </span>
                                <h4 className="fw-bold mb-3 fs-5" style={{ color: '#0f172a' }}>
                                    {item.title}
                                </h4>
                                <p className="text-muted mb-0 fs-6" style={{ fontSize: '14px', lineHeight: '1.5' }}>
                                    {item.description}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}